import { useFormContext } from 'react-hook-form';

import { RecipientInfoProps } from './types';
import { toUsFormat } from 'utils/utils';

import * as Styled from './RecipientInfo.styles';

export const RecipientInfo = ({ ticketTypes, recipientId }: RecipientInfoProps) => {
	const { watch } = useFormContext();
	const email = watch(`recipients[${recipientId}].email`);
	const day = watch('day.label');
	const time = watch('time.label');
	return (
		<Styled.RecipientInfo>
			{<Styled.Info>{email ? `${email}:` : 'No email'} </Styled.Info>}
			<Styled.Info>
				<strong>{day}</strong> {time}
			</Styled.Info>
			{ticketTypes.map(({ type, initialPrice, quantity }) =>
				quantity > 0 ? (
					<Styled.Info key={type}>
						{type} ({quantity}) <strong>{toUsFormat(initialPrice * quantity)}</strong>
					</Styled.Info>
				) : null
			)}
		</Styled.RecipientInfo>
	);
};
